import { useEffect, useState } from 'react';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import useTooltips from '../hooks/useTooltips ';
import usePageTitle from '../hooks/usePageTitle';
import { ENDPOINT_GALLERY } from '../Config';
import CopyableInput from './CopyableInput';
import ImageUploadCrop from './ImageUploadCrop';
import MessageConfiguration from './MessageConfiguration';
import { Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons';
import useProps from '../hooks/useProps';
import useAuth, { useGetFeatureCreateNewGallery } from '../hooks/useAuth';
import BillingFeatureCTA from './BillingFeatureCTA';

const Invite = () => {
    const { groupId } = useParams();
    usePageTitle('Activate Speaker');
    useTooltips();
    const { auth } = useAuth();
    const { props } = useProps();
    const [eventData, setEventData] = useState(null);
    const [gallery, setGallery] = useState(null);
    const [loading, setLoading] = useState(true);
    const [gallerySaving, setGallerySaving] = useState(false);
    const [gallerySuccess, setGallerySuccess] = useState(false);
    const [galleryError, setGalleryError] = useState(false);
    const axiosPrivate = useAxiosPrivate();
    const [uploadedImage, setUploadedImage] = useState(null);
    const featureCreateNewGallery = useGetFeatureCreateNewGallery();

    const handleImageUpload = (base64Image) => {
        setUploadedImage(base64Image);
    };

    const createGallery = async () => {
        setGallerySaving(true);
        setGalleryError(null);
        try {
            const response = await axiosPrivate.post(ENDPOINT_GALLERY.replace('{groupId}', groupId), {});
            if (response.status === 202) {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
            setGalleryError(error.response.data);
        } finally {
            setGallerySaving(false);
        }
    }
    const updateGallery = async () => {
        setGallerySaving(true);
        try {
            const response = await axiosPrivate.put(ENDPOINT_GALLERY.replace('{groupId}', groupId), {
                title: gallery.title,
                description: gallery.description,
                ...(uploadedImage && { logoData: uploadedImage })
            });
            if (response.status === 202) {
                setGallerySuccess(true);
                setTimeout(() => setGallerySuccess(false), 5000);
                if (uploadedImage) {
                    setGallery((prev) => ({
                        ...prev,
                        logo: uploadedImage
                    }));
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setGallerySaving(false);
        }
    }

    useEffect(() => {
        setGallery(eventData?.gallery);
    }, [eventData]);


    return (
        <section>
            <div className="container">
                <div className='row'>
                    <div className='col-5'>
                        <MessageConfiguration onReady={(response) => {
                            setEventData(response)
                            setLoading(false);
                        }} />
                    </div>
                    <div className='col-7'>
                        {!loading &&
                            <>
                                <h5 className="mb-3">{props.galleryHeading}</h5>
                                {gallery ?
                                    <>
                                        <div className='card text-bg-light mb-3'>
                                            <div className='card-body'>
                                                <div className='row gx-2'>
                                                    <div className='col'>
                                                        <div className='mb-3'>
                                                            <label htmlFor='galleryTitle' className="form-label">Headline</label>
                                                            <input type='text' id='galleryTitle'
                                                                className='form-control form-control-sm'
                                                                onChange={e => setGallery((prev) => ({
                                                                    ...prev,
                                                                    title: e.target.value
                                                                }))}
                                                                value={gallery.title}
                                                            />
                                                        </div>
                                                        <div className='mb-3'>
                                                            <label htmlFor='galleryDescription' className="form-label">Description</label>
                                                            <textarea id='galleryDescription' className='form-control form-control-sm' rows={3}
                                                                onChange={e => setGallery((prev) => ({
                                                                    ...prev,
                                                                    description: e.target.value
                                                                }))}
                                                                value={gallery.description}></textarea>
                                                        </div>
                                                    </div>
                                                    <div className='col-auto'>
                                                        <div>
                                                            <label className="form-label">Logo</label>
                                                            <ImageUploadCrop currentImage={gallery.logo} defaultImage={auth.logo} width={270} height={100} onImageUpload={handleImageUpload} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-footer'>
                                                <button type="button" className="btn btn-primary" onClick={updateGallery} disabled={gallerySaving}>
                                                    {gallerySaving ?
                                                        <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving gallery</>
                                                        : "Save"
                                                    }
                                                </button>
                                                <span className='ms-3'>
                                                    {gallerySuccess &&
                                                        <span className="text-success">
                                                            <FontAwesomeIcon icon={faCheck} /> saved
                                                        </span>
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className='card text-bg-light'>
                                            <div className='card-body'>
                                                <div className='mb-3'>
                                                    <label className="form-label">Gallery Link</label>
                                                    <CopyableInput value={gallery.publicURL} />
                                                </div>
                                                <div>
                                                    <label className="form-label">Embed Your Gallery with this Code</label>
                                                    <CopyableInput value={gallery.embedCode} isTextArea={true} rows={1} />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className='text-center'>
                                                    <BillingFeatureCTA feature={featureCreateNewGallery} unitName='video Gallery' type='button' onClick={createGallery} disabled={gallerySaving}>
                                                        {gallerySaving ?
                                                            <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Creating a Gallery</>
                                                            : "Create a Gallery"
                                                        }
                                                    </BillingFeatureCTA>
                                                    {galleryError &&
                                                        <div className='text-danger mt-3'>
                                                            {galleryError}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        }

                    </div>
                </div>
                {eventData &&
                    <div className='text-end'>
                        <Button size="lg" variant="light" as={Link} to="/" className='me-3'>Back</Button>
                        <Button size="lg" variant="secondary" as={Link} to={`/group/${groupId}/speakers`}>Next <FontAwesomeIcon icon={faArrowAltCircleRight} fixedWidth></FontAwesomeIcon></Button>
                    </div>
                }
            </div>
        </section >
    )
}

export default Invite
